import { Component, OnInit } from '@angular/core';
import { MarketplaceService, PopulationQuery } from '@fgb/core';
import { Populations } from 'src/app/shared/utilities/populations';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-events-page',
  templateUrl: './events-page.component.html',
  styleUrls: ['./events-page.component.scss'],
})
export class EventsPageComponent implements OnInit {
  populations = Populations;
  isCorporate: boolean;
  constructor(private populationQuery: PopulationQuery, private marketplaceService: MarketplaceService) {}

  ngOnInit() {
    firstValueFrom(this.marketplaceService.fetchMarketplaceItems());
    this.isCorporate = this.populationQuery.userInPopulation([this.populations.Hospitality]);
  }
}
